module.exports = __webpack_public_path__ + "static/media/data-collection.9bd840ce.svg";